export default __webpack_public_path__ + "static/designer-7acebf466d02e117f0f2f737c2eaef3d2dcb044f5535769e0ad69763e7639b8c.png";